import { LogOut } from "lucide-react";
import { useAuthUser } from "../../hooks/useAuthUser";
import { logout } from "../../services/auth";
import { Breadcrumb } from "./Breadcrumb";
import { BackendStatusDot } from "./BackendStatusDot";
import { cn } from "../../utils/cn";

// SPEC-20260505-1712: roles reais do realm wynk-platform.
const ROLE_BADGE_CLS: Record<string, string> = {
  "platform-master": "bg-primary-soft text-primary-soft-fg",
  "platform-admin": "bg-primary-soft text-primary-soft-fg",
  "platform-operations": "bg-success-soft text-success-soft-fg",
  "platform-read-only": "bg-surface-3 text-foreground-muted",
  "support-l3": "bg-warning-soft text-warning-soft-fg",
  "dev-on-call": "bg-warning-soft text-warning-soft-fg",
};

export function Topbar() {
  const { user } = useAuthUser();

  const onLogout = () => {
    void logout();
  };

  return (
    <header
      className="h-12 bg-topbar border-b border-topbar-border flex items-center justify-between px-4 shrink-0"
    >
      <div className="flex items-center gap-3">
        <Breadcrumb />
      </div>

      <div className="flex items-center gap-4">
        <BackendStatusDot />

        {user && (
          <div className="flex items-center gap-2.5 pl-3 border-l border-border">
            <div className="flex flex-col text-right leading-tight">
              <span className="text-xs font-medium text-foreground">{user.name ?? user.sub}</span>
              <div className="flex justify-end gap-1 mt-0.5">
                {user.roles.map((role) => (
                  <span
                    key={role}
                    className={cn(
                      "inline-block px-1.5 py-0.5 rounded text-[9.5px] font-medium font-mono-tight tracking-tight",
                      ROLE_BADGE_CLS[role] ?? "bg-surface-3 text-foreground-muted",
                    )}
                  >
                    {role}
                  </span>
                ))}
              </div>
            </div>
            <button
              type="button"
              onClick={onLogout}
              className="p-1.5 rounded hover:bg-surface-2 text-muted-foreground hover:text-foreground transition-colors"
              title="Sair"
              aria-label="Sair"
            >
              <LogOut size={15} strokeWidth={1.75} />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
